
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnLaborGrid extends Serenity.EntityGrid<ApprovalOutReturnLaborRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutReturnLabor'; }
        protected getIdProperty() { return ApprovalOutReturnLaborRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutReturnLaborRow.localTextPrefix; }
        protected getService() { return ApprovalOutReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}